export default __webpack_public_path__ + "static/media/salon-software.bc8d83b9.jpg";